import { pushInboxService } from './pushInboxService.js';

export const pushDeviceSession = { device: null, boundUser: '' };
export async function unlinkPushDevice() {
    if (pushDeviceSession.device && pushDeviceSession.boundUser) await pushInboxService.unregister(pushDeviceSession.device);
    pushDeviceSession.boundUser = '';
    if (typeof document !== 'undefined' && typeof window !== 'undefined' && (window.__CORECRY_IOS_BUILD__ || window.__CORECRY_DESKTOP__)) {
        document.documentElement.dataset.pushBadge = '0';
    }
}
